import React, { ChangeEvent, Component, ReactNode } from 'react';
import { CaseChartPanel, CaseFieldPanel, CasePanel, CasePanelType } from '../../../../../domain/case/CaseDomains';
import RoleHelper from '../../../../../RoleHelper';
import FormicaToggleSwitch from '../../../../custom/FormicaToggleSwitch';
import { customConfirm } from '../../../../custom/CustomPopupConfirm';
import LanguageUtil from '../../../../../util/LanguageUtil';
import { generateUUID } from '../../../../../util/Generator';
import Icon from '../../../../../icons/Icon';
import ComponentName from '../../../../../constant/ComponentName';

class DomainConfigurationCardContainer extends Component<Props, State> {
  public state: State = new State();

  public render() {
    const { panel, disabled, deletePanel, content, type, index } = this.props;
    const cursorClass = disabled ? 'cursor-not-allowed' : 'cursor-pointer';
    return (
      <div
        className={`flex flex-col ${panel.gridType == 'even' ? 'col-span-2' : 'col-span-1'} bg-white border-[#E0E4E8] w-full h-[340px]  border-[1px] rounded-[10px]`}
        data-testid={`${ComponentName.CONFIGURATION}_panel_${index}_container`}
      >
        <span className='flex flex-row px-5 w-full rounded-t-[10px] bg-main-gray border-b-[1px] justify-between '>
          <input
            className={'bg-transparent w-full outline-none border-none 2xl text-primary placeholder:text-primary'}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.addSubtitle', defaultMessage: '+ Add a subtitle' })}
            value={panel.title}
            disabled={!RoleHelper.canEdit('CaseConfiguration')}
            onChange={this.onChangeName}
            data-testid={`${ComponentName.CONFIGURATION}_panel_${index}_title_input`}
          />
          <div className={'flex box-border h-12 gap-x-2 items-center'}>
            {type == CasePanelType.PANEL && (
              <span className={`${cursorClass}`} onClick={() => this.addField()} data-testid={`${ComponentName.CONFIGURATION}_panel_${index}_add_field_button`}>
                <Icon size={20} className={'text-f-black-2'} icon={'add'} />
              </span>
            )}
            <span
              className={`${cursorClass}`}
              onClick={(e) => {
                if (disabled) return;
                e.stopPropagation();
                e.preventDefault();
                customConfirm({
                  target: e.currentTarget,
                  accept: () => deletePanel(panel),
                  message: LanguageUtil.get({ id: 'messages.confirm.deploy1', defaultMessage: 'Are you sure you want to remove?' }),
                });
              }}
              data-testid={`${ComponentName.CONFIGURATION}_panel_${index}_remove_button`}
            >
              <Icon icon={'delete'} size={20} className={`text-primary ${cursorClass}`} />
            </span>
            <span className={'flex h-full items-center'}>
              <FormicaToggleSwitch
                value={panel.enabled}
                onChange={this.togglePanelEnabled}
                disabled={!RoleHelper.canEdit('CaseConfiguration')}
                data-testid={`${ComponentName.CONFIGURATION}_panel_${index}_enabled_switch`}
              />
            </span>
            <span className={'flex bg-[#EDEDED] rounded-[4px] gap-x-1 px-1 py-1'}>
              <div
                onClick={() => this.onChangeGridType('odd')}
                className={`${panel.gridType == 'odd' ? 'bg-white opacity-100' : 'opacity-50'} px-1 py-1 ${cursorClass} rounded-[2px] flex gap-x-0.5 items-center `}
                data-testid={`${ComponentName.CONFIGURATION}_panel_${index}_grid_type_odd_button`}
              >
                <div className={'bg-f-black-2 h-3 w-1 rounded-[1px]'} />
                <div className={'bg-f-black-2 h-3 w-1 rounded-[1px]'} />
              </div>
              <div
                onClick={() => this.onChangeGridType('even')}
                className={`${panel.gridType == 'even' ? 'bg-white opacity-100' : 'opacity-50'} px-1 py-1 ${cursorClass} rounded-[2px] flex items-center `}
                data-testid={`${ComponentName.CONFIGURATION}_panel_${index}_grid_type_even_button`}
              >
                <div className={'bg-f-black-2 h-3 w-3 rounded-[1px]'}></div>
              </div>
            </span>
          </div>
        </span>
        {content}
      </div>
    );
  }

  private onChangeName = (e: ChangeEvent<HTMLInputElement>) => {
    const { panel, changePanel } = this.props;
    const { disabled } = this.props;
    if (disabled) return;
    panel.title = e.currentTarget.value;
    changePanel();
  };

  private onChangeGridType = (gridType: 'even' | 'odd') => {
    const { panel, changePanel } = this.props;
    const { disabled } = this.props;
    if (disabled) return;
    panel.gridType = gridType;
    changePanel();
  };

  private addField = () => {
    const { disabled } = this.props;
    if (disabled) return;
    const { changePanel, panel } = this.props;
    if ('fields' in panel) {
      panel?.fields.push({
        title: '',
        type: '',
        value: '',
        key: generateUUID(),
      });
    }
    changePanel();
  };

  private togglePanelEnabled = () => {
    const { panel, changePanel } = this.props;
    const { disabled } = this.props;
    if (disabled) return;
    panel.enabled = !panel.enabled;
    changePanel();
  };
}

interface Props {
  panel: CaseFieldPanel | CaseChartPanel;
  changePanel: () => void;
  deletePanel: (panel: CasePanel) => void;
  disabled: boolean;
  content: ReactNode;
  type: CasePanelType;
  index: number;
}

class State {}

export default DomainConfigurationCardContainer;
